export default "__VITE_ASSET__CHqaCSpH__"